import { action, makeAutoObservable, makeObservable, observable, isObservableProp } from "mobx"
import DataLoading from "react-sdk/DataLoading"
import Texts from "react-sdk/Texts"

import { getUrlVar } from "react-sdk/utils"
// import SoundPlayer from "react-sdk/SoundPlayer";
import Config from "react-sdk/Config"
import ScaleManager from "react-sdk/ScaleManager"

import SequencesManager from "react-sdk/haxelibs/SequencesManager"
import SoundPlayer from "react-sdk/SoundPlayer"
import Analytics from "react-sdk/Vertx/Analytics"

import Dials from "./Dials"
import ReaxeAPI from "./ReaxeAPI"
import SequenceScenario from "./SequenceScenario"

import ObjectiveFile from "react-sdk/Objectives/ObjectiveFile"
import BlocNote from "./BlocNote/BlocNote"
import Chapter from "./Chapter"
import Chapters from "./Chapters"
import Ftues from "./Ftues"
import Minigames from "./Minigames/Minigames"
import PopupsManager from "react-sdk/PopupsManager"
import { Group } from "./Group"
import VertxHelper from "./VertxHelper"
import MeetingsApi from "react-sdk/Vertx/MeetingsApi/MeetingsApi"
import SaveGame from "./SaveGame"
import Slides from "./Slides"
import AstekActivity from "./AstekActivity"
import Loading from "./Loading"


const VertxClient = window.gms.VertxClient

// NOTE je fais ça pour tester, ca serait bien de pouvoir générer ça en auto...
/**
 * @typedef VertxClientDef
 * @type {object}
 * @property {object} UserData
 * @property {function} UserData.getUniverse
 * @property {function} UserData.getPseudo
 * @property {function} UserData.getUserMail
 * @property {function} UserData.getUserID
 */

export const SCREENS = {
  NONE: "NONE",
  LOADING: "LOADING",
  HOME: "HOME",
  MODULES: "MODULES",
  WELCOME: "WELCOME",
  VIDEO: "VIDEO",
  GAME: "GAME",
  ECRAN_FINAL: "ECRAN_FINAL",
}

export const POPUPS = {
  NEW_OBJECTIVE: "NEW_OBJECTIVE",
  NOTIF: "NOTIF",
  MINIGAME_STARS : "MINIGAME_STARS",
  CHAPTER_END : "CHAPTER_END",
  MINIGAME_INTRO:"MINIGAME_INTRO",
  FTUE:"FTUE",
  RECOMMANDATIONS: "RECOMMANDATIONS",
  SLIDES : "SLIDES",
  MENTIONS_LEGALES: "MENTIONS_LEGALES",
  CREDITS : "CREDITS",
  NEW_DAY : "NEW_DAY",
  IMG_FS : "IMG_FS",
  PLACEHOLDER : "PLACEHOLDER",
  LEADERBOARD : "LEADERBOARD"
}

class AppState {
  debugMode = false
  skipDial = false
  skipAct = false
  allPlayable = false

  language = "fr"
  screen = SCREENS.NONE

  /** @type {Array<Group>} */
  groupList = []
  /** @type {Group} */
  group = null

  /** @type {ReaxeAPI} */
  reaxe_api = null

  /** @type {VertxHelper} */
  vertxHelper = null
  /** @type {VertxClientDef} */
  vertxClient = null
  connected = false

  // SaveData de haxe, pour accéder au CD si besoin
  currentSave = null

  haxeCanvas = null
  haxeBackendVisible = false

  UI_visibilities = {}
  forceClickUIElements = {}
  hudVisibility = true;
  lockHud = false // HACK

  nextButtonCallBack = null;

  /** @type {ObjectiveFile} */
  objectives = null

  /** @type {Chapter} */
  currentChapter = null

  /** @type {AstekActivity} */
  astekActivity = null

  isGameStarted = false

  evalToUnlock = false

  leaderboardDisabled = false

  constructor() {
    this.debugMode = getUrlVar("debug") !== null
    this.skipAct = getUrlVar("skipAct") !== null
    this.skipDial = getUrlVar("skipDial") !== null
    this.allPlayable = getUrlVar("allPlayable") !== null

    /*let h = window.innerHeight
    let w = window.innerWidth
    let finalH = 1920
    let finalW = (w * finalH) / h
    finalW = clamp(850, 1200, finalW)*/
    let finalW = 1920
    let finalH = 1080

    ScaleManager.init(finalW, finalH)

    SequencesManager.variables.verbose = false

    let requiredFiles = window.CONFIG.requiredFiles;
    DataLoading.getAllFiles(requiredFiles, "")
      .then(files => {
        Config.init(files.config)

        this.reaxe_api = new ReaxeAPI()
        this.haxeCanvas = document.createElement("canvas")

        Texts.init(files.texts, this.language)
        this.dials = new Dials(this.reaxe_api, getUrlVar("skip") !== null)
        this.dials.addDialFile(requiredFiles.dials)

        Slides.init(files.slides)
        SoundPlayer.init(files.audio)
        Chapters.init(requiredFiles.chapters)
        Minigames.init(
          requiredFiles.minigames,
          files
        )
        Chapters.all.forEach(c => c.initMgValues())
        Ftues.init(files.ftues)

        this.objectives = new ObjectiveFile(requiredFiles.objectives)
        
        SequenceScenario.init()
        //SequenceScenario.addFile(requiredFiles.sequences)
      })
      // .then(() => this.handleVertxConnection())
      // .then(() => this.reaxe_api.api.vertxClient = this.vertxClient)
      .then(() => {

        this.demoSave = getUrlVar("save")
        if (this.demoSave)
          this.demoSave = "saves/" + this.demoSave + ".json"
        window.lime.embed(
          "backend-haxe",
          this.haxeCanvas,
          ScaleManager.w,
          ScaleManager.h,
          {
            parameters: {
              logLevel: Config.get("haxe_loglevel"),
              reaxe_api: this.reaxe_api.api,
              app:
              {
                display: { // dans notre cas, ça setup la taille du level
                  width: 1280,
                  height: 720
                },
                script: {
                  projectFile:"data/game.scp"
                },
                save: {
                  customSaveFilePath: this.demoSave
                }
              }
            },
          }
        )
      })


    makeAutoObservable(this, {
      reaxe_api: false,
      haxeCanvas: false
    })
  }

  checkLeaderboardDisabled() {
    let dateStr = Texts.get("leaderboard-disable-date")
    if (dateStr) {
      let date = new Date(dateStr)
      if (!isNaN(date.valueOf())) {
        this.leaderboardDisabled = new Date() > date
        if (!this.leaderboardDisabled) {
          let time = date.getTime() - Date.now()
          setTimeout(() => this.leaderboardDisabled = true, time)
        }
      }
    }
  }

  handleVertxConnection() {
    this.helper = new VertxHelper(window.CONFIG.vertx)
    this.vertxClient = this.helper.vertxClient
    return this.helper.connect()
      .then(connected => {
        console.log("connected", connected)
        Analytics.init(this.vertxClient)

        if (connected) {
          this.connected = true

          if (!isObservableProp(this.vertxClient.UserData, "_Pseudo")) {
            makeObservable(this.vertxClient.UserData, {
              _Pseudo: observable,
              setPseudo: action,
            })
          }

          return this.getUserTeamInfo()
          .then(() => this.connectToGlobalMeeting())

        }
      })
  }
  
  loginWithCode(email, code) {
    return this.helper.loginWithCode(email, code)
      .then(() => {
        this.connected = true

        if (!isObservableProp(this.vertxClient.UserData, "_Pseudo")) {
            makeObservable(this.vertxClient.UserData, {
              _Pseudo: observable,
              setPseudo: action,
            })
          }

        return this.getUserTeamInfo()
        .then(() => this.connectToGlobalMeeting())
      })
  }
  
  logout() {
    return this.helper.logout()
      .then(() => {
        this.connected = false
        this.group = null
      })
  }

  getUserTeamInfo() {
    return new Promise((resolve) => {
      this.vertxClient.GroupFindUserGroups(this.vertxClient.UserData.getUserID(), (success, msg, groups) => {
        groups = groups.filter(g => g != "admin" && g != "superadmin")
        if (success && groups.length >= 1) {
            this.group = new Group(groups[0])
            console.log("user group : " + this.group.groupId)
            this.group.fetchInfos().then(resolve)
        } else {
          this.group = null
          console.log("no user group")
          resolve()
        }
      })
    })
  }

  connectToGlobalMeeting() {
    return new Promise((resolve, reject) => {

      // si on est pas dans un groupe, on skip et on refera la connexion au meeting lorsqu'on aura choisi un groupe
      if (!this.group) {
        resolve()
        return
      }
      
      // ici on se connecte au meeting !!!!
      let code = window.CONFIG.meetingCode
      let pseudo = this.vertxClient.UserData.getPseudo()

      if (code) {
        MeetingsApi.init(this.vertxClient)

        MeetingsApi.meetingConnectWithcode(code, pseudo)
          .then(m => {
            this.currentMeeting = m
            this.currentMeeting.onMeetingMessage = message => {
              console.log("New meeting message", message)
            }

            console.log("connected to meeting")
          })
          .then(() => this.currentMeeting.getActivities())
          .then(() => {
            this.astekActivity = new AstekActivity(this.currentMeeting)
            return this.astekActivity.refreshUserResults()
          })
          .then(() => resolve())
      } else
        resolve()
    })
  }


  /**
   * 
   * @returns {Promise<Array<Group>>}
   */
  getGroupList() {
    return new Promise((resolve, reject) => {
      if (this.groupList.length > 0)
        resolve(this.groupList)
      else {
        this.vertxClient.GroupGetList(null, null, (success, msg, groupIds) => {

          if (success && groupIds.length >= 1) {
            this.groupList = groupIds.filter(groupId => groupId !== "admin" && groupId !== "superadmin").map(groupId => new Group(groupId))
            let promises = []
            this.groupList.forEach(group => {
              promises.push(group.fetchInfos())
            })
            Promise.all(promises).then(() => {
              resolve(this.groupList)
            })
          } else {
            console.log("Aucun groupe ou erreur (" + msg + ")")
            resolve(this.groupList)
          }
        })
      }
    })
  }

  launchChapter(chapter) {
    this.currentChapter = chapter

    // this.setScreen(SCREENS.LOADING)
    //Chronometre.start()
    Loading.show().then(() => {
      // y'a 2 cas :
      // A - si c'est le 1er lancement de chapitre de la session
      // si pas de save, on en crée une nouvelle => startGame(false), quand c'est ready, on set le chapitre inProgress, on update la save et on lance le trigger du module
      // sinon, si le chapitre est inProgress on load => startGame(true) puis c'est tout, et si il n'est pas inProgress, on load (ça devrait pas replay d'actions), puis on set le chapitre inProgress, on update la save et on lance le trigger du module
      // B - on lance un autre chapitre après avoir fini un chapitre
      // on set le chapitre inProgress, on update la save et on lance le trigger du module

      if (this.isGameStarted) {
        this.#startCurrentChapterScript()
      } else {
        if (this.currentSave == null) {
          this.startGame(false)
        } else {
          this.startGame(true)
        }
      }
    })
  }

  #startCurrentChapterScript() {
    this.haxeBackendVisible = true
    this.setScreen(SCREENS.GAME)
    if (!this.currentChapter.inProgress) {
      this.currentChapter.inProgress = true
      SaveGame.updateState()
      this.reaxe_api.toHaxe("game", "triggerScript", { trigger : "Standard", triggerValue : this.currentChapter.scriptTrigger})
    } else
      Loading.hide()
    this.objectives.refreshObjectivesState()

  }

  terminateCurrentChapter() {
    if (this.currentChapter) {
      this.currentChapter.inProgress = false
      this.currentChapter.finished = true
      let chapterMgs = Minigames.all.filter((mg) => mg.chapter == this.currentChapter)
      let chapterStars = chapterMgs.reduce((total, mg) => total + mg.getStars(), 0)
      this.currentChapter.stars = chapterStars;
      SaveGame.updateState()
      this.currentChapter = null
    }
  }

  showEndScreen() {
    this.setScreen(SCREENS.ECRAN_FINAL);
    this.haxeBackendVisible = false
  }

  goBackToModulesChoiceScreen() {
    this.setScreen(SCREENS.MODULES);
    this.haxeBackendVisible = false
  }

  initCharacters() {
    // pas besoin du charEngine comme on n'utilise que des persos animate
    // window.SpeechAPI.waitCharacterEngine(false)
    //window.SpeechAPI.setLogLevel(Config.get("speechapi_loglevel"))

    return new Promise(resolve => {
      window.SpeechAPI.initCharacters(
        window.CONFIG.requiredFiles.characters,
        () => {
          console.log("initCharacters done")
          window.SpeechAPI.loadCharacterIds(["avatar"], () => {
            console.log("loadCharacterIds done")

            resolve()

          })
        }
      )
    })
  }


  setScreen(id) {
    if (this.vertxClient)
      Analytics.changeScreenEvents(this.screen, id)
    this.screen = id
  }

  onBackendReady() {
    this.listenHaxeGameModule()
  }

  onBackendWaiting() {
    this.#retrieveSave().then(() => {
      this.initCharacters().then(() => {
        this.gameReady = true
        this.showFirstScreen()
      })
    })
  }

  #retrieveSave() {
    return new Promise(resolve => {
      if (this.demoSave) {
        this.reaxe_api.api.registeredFunctions.getSave(save => {
          this.#initSave(save)
          resolve()
        })
      } else {
        resolve()
      }
    })
  }
  #initSave(save) {
    this.currentSave = save
    SaveGame.init(this.reaxe_api, save)
  }

  showFirstScreen() {
    this.checkLeaderboardDisabled()
    SoundPlayer.playSound("login")
    // if (this.connected && this.group) // si connecté et déjà dans un groupe, on affiche direct l'écran de sélection des chapitres
      this.setScreen(SCREENS.MODULES)
    // else
    //   this.setScreen(SCREENS.HOME)
    Loading.hide()
  }

  deleteSave(clearGroup) {
    if (this.astekActivity) {
      this.astekActivity.clearUserResults(clearGroup)
        .then(() => this.reaxe_api.api.registeredFunctions.deleteSave(() => { window.location.reload()}))
    } else 
      this.reaxe_api.api.registeredFunctions.deleteSave(() => { window.location.reload()})
  }

  startGame(continueGame) {
    this.reaxe_api.api.registeredFunctions.startGame(continueGame)
    // on devrait tomber dans le event "GameLoaded" envoyé par le jeu quand le jeu est lancé ou la partie chargée
  }

  listenHaxeGameModule() {

    this.reaxe_api.registerModule("game", (event, params, done) => {

      if (event == "GameLoaded") {
        this.isGameStarted = true
        this.#initSave(params)
        
        this.#startCurrentChapterScript()
        
      } else if( event === "showAllUi") {    
          this.UI_visibilities = Object.fromEntries(
            Object.keys(this.UI_visibilities).map(k => [k, params])
          );  
      } else if(event === "changeMusic") {    
          SoundPlayer.playSound(params.get()) 
          SaveGame.updateState()
      }

      if(done)
        done()
    })

    this.reaxe_api.registerModule("loading", (event, params, done) => {

      if (event == "show") {
        Loading.show().then(() => done())
        return
      } else if( event == "hide") {
        Loading.hide().then(() => done())
        return
      }

      if(done)
        done()
    })
  }


}

export default new AppState()
